import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.sso-saaspass', {
        url: '/ssosaaspass/:content',
        component: 'clientSsoSaaspassLogin',
    })
}



// WEBPACK FOOTER //
// ./src/portal/states/public/client-sso-saaspass-login/client-sso-saaspass-login.state.js